import { FilterState } from "models/propTypes/filterPropTypes";
import { FilterActionType } from "models/actionTypes/filterActionTypes";
import { ContextConstants } from "utils/constants";

export const FilterReducer = (state: FilterState<any>, action: FilterActionType) => {
  switch (action.type) {
    case ContextConstants.FilterActions.SET_FILTER:
      return { ...state, filter: action.payload };
    case ContextConstants.FilterActions.TOGGLE_FILTER:
      return { ...state, isOpen: !state.isOpen };
    case ContextConstants.FilterActions.SET_FILTER_COUNT:
      return { ...state, count: action.payload };
    default:
      return state;
  }
};
